import AsyncStorage from '@react-native-async-storage/async-storage';
import { Platform } from 'react-native';

import { parseTextSize, textSizeZoom, type TextSize } from './text-size';

const STORAGE_KEY = '@nearkin/text-size';

// Web only: the app ships to the web today, and CSS zoom on the document is
// what scales type and spacing together. A no-op elsewhere.
export function applyTextSize(size: TextSize): void {
  if (Platform.OS === 'web' && typeof document !== 'undefined') {
    document.documentElement.style.setProperty('zoom', String(textSizeZoom(size)));
  }
}

export async function loadTextSize(): Promise<TextSize> {
  try {
    return parseTextSize(await AsyncStorage.getItem(STORAGE_KEY));
  } catch {
    return 'default';
  }
}

export async function saveTextSize(size: TextSize): Promise<void> {
  applyTextSize(size);
  await AsyncStorage.setItem(STORAGE_KEY, size).catch(() => {});
}
